<template>
  <div class="fan fan-component f-plugin-tree-tab">
    <f-layout ref="flayout"
              :superPage="page"
              :superApi="superApi"
              @reloadData="reloadData">

      <!-- 头部 -->
      <!-- <template #head v-if="superTitle">
        <div style="font-weight:bold; padding:0;">{{ superTitle }}</div>
      </template> -->

      <!-- 搜索栏 -->
      <template #subHeadLeft>
        <f-search :key="activeTab1 + '_' + activeTab2"
                  :superFilter="filter"
                  :superColumns="activeColumns"
                  @change="handleSearchChange"
                  @reloadData="reloadData" />
      </template>

      <!-- 主体 -->
      <template #body>
        <div class="tree-tab-layout">
          <!-- 左侧树 -->
          <div class="left-tree" v-if="treeData.length > 0">
            <a-input-search
              v-model="treeSearch"
              placeholder="搜索"
              style="margin-bottom: 8px"
            />
            <a-tree
              :data="filteredTreeData"
              :selected-keys="selectedKeys"
              :default-expanded-keys="defaultExpandedKeys"
              show-line
              @select="handleTreeSelect"
            />
          </div>

          <!-- 右侧内容区 -->
          <div class="right-content">
            <!-- 多级 tabs -->
            <div class="tabs-bar" v-if="tabList.length > 0">
              <!-- 一级 tab -->
              <div class="tab-level" v-if="tabList.length > 0">
                <a-radio-group
                  v-model="activeTab1"
                  type="button"
                  size="small"
                  @change="handleTab1Change"
                >
                  <a-radio
                    v-for="tab in tabList"
                    :key="tab.value"
                    :value="tab.value"
                  >{{ tab.name || tab.label }}</a-radio>
                </a-radio-group>
              </div>
              <!-- 二级 tab -->
              <div class="tab-level" v-if="subTabList.length > 0">
                <a-radio-group
                  v-model="activeTab2"
                  type="button"
                  size="small"
                  @change="handleTab2Change"
                >
                  <a-radio
                    v-for="tab in subTabList"
                    :key="tab.value"
                    :value="tab.value"
                  >{{ tab.name || tab.label }}</a-radio>
                </a-radio-group>
              </div>
            </div>

            <!-- 卡片列表 -->
            <a-spin :loading="loading" tip="加载中...">
              <div class="card-grid" v-if="dataList.length > 0">
                <div
                  v-for="item in dataList"
                  :key="item.id"
                  class="device-card"
                  @click="handleView(item)"
                >
                  <div class="card-header">
                    <span class="device-name">{{ getFieldValue(item, titleField) || item.name || '-' }}</span>
                  </div>
                  <div class="card-body">
                    <div class="device-image" v-if="imageField">
                      <img v-if="getFieldValue(item, imageField)" :src="getFieldValue(item, imageField)" alt="" />
                      <div v-else class="no-image">
                        <icon-robot style="font-size: 48px; color: #c9cdd4" />
                      </div>
                    </div>
                    <div class="device-info" :class="{ 'full-width': !imageField }">
                      <div
                        v-for="col in infoColumns"
                        :key="col.dataIndex"
                        class="info-row"
                      >
                        <span class="label">{{ col.title }}：</span>
                        <span class="value">{{ getDisplayValue(item, col) }}<template v-if="col.unit"> {{ col.unit }}</template></span>
                      </div>
                    </div>
                  </div>
                  <!-- 自定义操作按钮 -->
                  <div class="card-actions" v-if="$slots.customAction" @click.stop>
                    <slot name="customAction" :record="item"></slot>
                  </div>
                </div>
              </div>
              <div v-else class="empty-tip">暂无数据</div>
            </a-spin>

            <!-- 分页 -->
            <div class="pagination-wrap">
              <a-pagination
                :total="total"
                :page-size="filter.limit"
                :current="filter.page"
                :page-size-options="[8, 12, 16, 24]"
                show-total
                show-page-size
                @change="handlePageChange"
                @page-size-change="handleSizeChange"
              />
            </div>
          </div>
        </div>
      </template>
    </f-layout>
  </div>
</template>

<script>
export default {
  name: 'FPluginTreeTab',
  props: {
    superTitle: { type: String, default: '' },
    superApi: { type: String, default: '' },
    superColumns: { type: Array, default: () => [] },
    superTreeApi: { type: String, default: '' },
    superTabApi: { type: String, default: '' },
    treeParam: { type: String, default: 'tree' },
    tabParam: { type: String, default: 'tab' },
    superColumnsMap: { type: Object, default: () => {} }
  },
  data() {
    return {
      page: {},
      loading: false,
      dataList: [],
      total: 0,
      filter: {},
      // 树
      treeData: [],
      treeSearch: '',
      activeNode: '',
      selectedKeys: [],
      // 标签页（多级）
      tabList: [],
      activeTab1: '',
      activeTab2: ''
    }
  },
  computed: {
    filteredTreeData() {
      if (!this.treeSearch) return this.treeData
      return this.filterTree(this.treeData, this.treeSearch)
    },
    defaultExpandedKeys() {
      if (!this.treeData.length) return []
      return [this.treeData[0].key]
    },
    activeColumns() {
      // 根据当前 tab 切换列配置
      if (this.activeTab2 && this.superColumnsMap[this.activeTab2]) {
        return this.superColumnsMap[this.activeTab2]
      }
      if (this.activeTab1 && this.superColumnsMap[this.activeTab1]) {
        return this.superColumnsMap[this.activeTab1]
      }
      return this.superColumns
    },
    titleField() {
      const cols = this.activeColumns
      const col = cols.find(c =>
        c.dataIndex && c.dataIndex !== 'id' && c.key !== 'action' &&
        (!c.hidden || !c.hidden.includes('list'))
      )
      return col ? col.dataIndex : 'name'
    },
    imageField() {
      const cols = this.activeColumns
      const col = cols.find(c => c.form === 'image' || c.form === 'upload')
      return col ? col.dataIndex : ''
    },
    subTabList() {
      if (!this.activeTab1) return []
      const parent = this.tabList.find(t => t.value === this.activeTab1)
      return (parent && parent.children) ? parent.children : []
    },
    infoColumns() {
      return this.activeColumns.filter(c => {
        if (!c.dataIndex) return false
        if (c.form === 'hidden') return false
        if (c.key === 'action') return false
        if (c.dataIndex === this.titleField) return false
        if (c.dataIndex === this.imageField) return false
        return true
      })
    }
  },
  mounted() { this.initPage() },
  activated() { this.initPage() },
  methods: {
    async initPage() {
      this.filter = { page: 1, limit: 12 }
      this.page = this.$fan.utils.parse({ loading: false, initing: false })
      this.$store.state.page.columns = {}
      this.$store.state.page.tableColumns = []
      this.$store.state.page.keyinfo = {}
      if (this.superColumns.length > 0) {
        await this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
      }
      if (this.superTreeApi) await this.loadTree()
      if (this.superTabApi) await this.loadTabs()
      if (this.superApi) this.loadData()
    },
    async loadTree() {
      try {
        const res = await this.$fan.api.get(this.superTreeApi)
        if (res && res.status === 0) {
          const raw = (res.data && res.data.data) ? res.data.data : []
          this.treeData = raw.map(n => this.mapTreeNode(n))
          if (this.treeData.length > 0) {
            const first = this.treeData[0]
            if (first.children && first.children.length > 0) {
              this.activeNode = first.children[0].key
              this.selectedKeys = [first.key, first.children[0].key]
            } else {
              this.activeNode = first.key
              this.selectedKeys = [first.key]
            }
          }
        }
      } catch {}
    },
    mapTreeNode(node) {
      const mapped = {
        key: node.key || node.id,
        title: node.name || node.title || node.label,
        ...node
      }
      if (node.children && node.children.length > 0) {
        mapped.children = node.children.map(c => this.mapTreeNode(c))
      }
      return mapped
    },
    async loadTabs() {
      try {
        const res = await this.$fan.api.get(this.superTabApi)
        if (res && res.status === 0) {
          const raw = (res.data && res.data.data) ? res.data.data : []
          // 支持 { name, value, children } 或 { label, value, children }
          this.tabList = raw.map(t => ({
            ...t,
            name: t.name || t.label,
            label: t.label || t.name,
            value: t.value || t.id,
            children: t.children ? t.children.map(c => ({
              ...c,
              name: c.name || c.label,
              label: c.label || c.name,
              value: c.value || c.id
            })) : undefined
          }))
          if (this.tabList.length > 0) {
            this.activeTab1 = this.tabList[0].value
            const children = this.tabList[0].children
            if (children && children.length > 0) {
              this.activeTab2 = children[0].value
            }
          }
        }
      } catch {}
    },
    filterTree(nodes, keyword) {
      if (!nodes || !nodes.length) return []
      return nodes.reduce((acc, node) => {
        const match = (node.title || '').toLowerCase().includes(keyword.toLowerCase())
        const children = this.filterTree(node.children, keyword)
        if (match || children.length > 0) {
          acc.push({ ...node, children })
        }
        return acc
      }, [])
    },
    handleTreeSelect(keys) {
      if (keys && keys.length > 0) {
        const node = this.findTreeNode(this.treeData, keys[0])
        // 查找所有祖先节点用于高亮
        const ancestors = this.findAncestorKeys(this.treeData, keys[0])
        this.selectedKeys = [...ancestors, keys[0]]
        // 有子节点时取第一个子节点 id 查询，并高亮子节点
        if (node && node.children && node.children.length > 0) {
          this.activeNode = node.children[0].key
          this.selectedKeys.push(node.children[0].key)
        } else {
          this.activeNode = keys[0]
        }
        this.filter.page = 1
        this.loadData()
      }
    },
    findAncestorKeys(nodes, key, parents = []) {
      if (!nodes || !nodes.length) return []
      for (const n of nodes) {
        if (n.key === key) return parents
        if (n.children) {
          const found = this.findAncestorKeys(n.children, key, [...parents, n.key])
          if (found.length > 0 || n.children.some(c => c.key === key)) return found.length ? found : [...parents, n.key]
        }
      }
      // BFS fallback
      for (const n of nodes) {
        if (n.children) {
          const result = this.findAncestorKeys(n.children, key, [...parents, n.key])
          if (result.length > 0) return result
        }
      }
      return []
    },
    findTreeNode(nodes, key) {
      if (!nodes || !nodes.length) return null
      for (const n of nodes) {
        if (n.key === key) return n
        if (n.children) {
          const found = this.findTreeNode(n.children, key)
          if (found) return found
        }
      }
      return null
    },
    handleSearchChange(changes = {}) {
      this.filter = { ...this.filter, ...changes, page: 1 }
      this.loadData()
    },
    async handleTab1Change(val) {
      this.activeTab1 = val
      // 切换一级时自动选二级第一个
      const parent = this.tabList.find(t => t.value === val)
      if (parent && parent.children && parent.children.length > 0) {
        this.activeTab2 = parent.children[0].value
      } else {
        this.activeTab2 = ''
      }
      await this.$fan.page.loadCallback(this.activeColumns, {}).catch(() => {})
      this.filter.page = 1
      this.loadData()
    },
    async handleTab2Change(val) {
      this.activeTab2 = val
      await this.$fan.page.loadCallback(this.activeColumns, {}).catch(() => {})
      this.filter.page = 1
      this.loadData()
    },
    async loadData() {
      if (!this.superApi) return
      this.loading = true
      try {
        const params = { page: this.filter.page, limit: this.filter.limit }
        // 只取 searchable 字段，过滤掉事件对象属性
        this.activeColumns.forEach(col => {
          if (col.search && col.dataIndex && this.filter[col.dataIndex] !== undefined && this.filter[col.dataIndex] !== '') {
            params[col.dataIndex] = this.filter[col.dataIndex]
          }
        })
        if (this.activeNode) params[this.treeParam] = this.activeNode
        if (this.activeTab2) {
          params[this.tabParam] = this.activeTab2
        } else if (this.activeTab1) {
          params[this.tabParam] = this.activeTab1
        }
        const res = await this.$fan.api.get(this.superApi, params)
        if (res && res.status === 0) {
          this.dataList = (res.data && res.data.data) ? res.data.data : []
          this.total = Number(res.data?.total || res.data?.count) || this.dataList.length
        }
      } catch {} finally { this.loading = false }
    },
    handlePageChange(page) {
      this.filter.page = page
      this.loadData()
    },
    handleSizeChange(size) {
      this.filter.limit = size
      this.filter.page = 1
      this.loadData()
    },
    reloadData() {
      this.filter = { page: 1, limit: 12 }
      this.loadData()
    },
    // 解析 dataIndex 路径，如 'values[0]' → obj.values[0], 'a.b.c' → obj.a.b.c
    getFieldValue(obj, path) {
      if (!obj || !path) return undefined
      const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.')
      let val = obj
      for (const k of keys) {
        if (val == null) return undefined
        val = val[k]
      }
      return val
    },
    // 通过 keyinfo 字典将 id 转换为显示名称
    getDisplayValue(item, col) {
      const raw = this.getFieldValue(item, col.dataIndex)
      if (raw == null || raw === '') return '-'
      if (['select', 'radio', 'cascader', 'selectMultiple'].includes(col.form)) {
        const keyinfo = this.$store.state.page?.keyinfo || {}
        const optMap = keyinfo[col.dataIndex]
        if (optMap && optMap[raw] && optMap[raw].name) return optMap[raw].name
        if (optMap && optMap[String(raw)] && optMap[String(raw)].name) return optMap[String(raw)].name
        // 多值逗号分隔
        if (typeof raw === 'string' && raw.includes(',')) {
          return raw.split(',').map(v => {
            const k = v.trim()
            if (optMap && optMap[k] && optMap[k].name) return optMap[k].name
            return k
          }).join(', ')
        }
      }
      return raw
    },
    async handleView(record) {
      await this.$fan.page.loadCallback(this.activeColumns, {}).catch(() => {})
      const flat = { ...record }
      // 嵌套字段展平 + select 值预转显示名
      const cols = this.$store.state.page.columns
      this.activeColumns.forEach(col => {
        if (!col.dataIndex) return
        if (col.dataIndex.includes('[') || col.dataIndex.includes('.')) {
          let val = this.getFieldValue(record, col.dataIndex)
          if (['select', 'radio', 'cascader'].includes(col.form)) {
            val = this.getDisplayValue(record, col)
            if (cols && cols[col.dataIndex]) cols[col.dataIndex].form = 'input'
          }
          if (col.unit && val != null && val !== '-') val = val + ' ' + col.unit
          flat[col.dataIndex] = val
        }
      })
      this.$refs.flayout.bindOpenCurd('详情', { record: flat })
    }
  }
}
</script>

<style scoped lang="less">
.f-plugin-tree-tab {
  height: 100%;
  display: flex;
  flex-direction: column;
  :deep(.f-layout-content),
  :deep(.f-layout-level2),
  :deep(.main),
  :deep(.mainBody),
  :deep(.mainContent),
  :deep(.content),
  :deep(.contentBody) {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  :deep(.contentBody) > div {
    flex: 1;
    display: flex;
    overflow: hidden;
  }
}

.tree-tab-layout {
  flex: 1;
  display: flex;
  gap: 16px;
  overflow: hidden;
}

.left-tree {
  width: 200px;
  flex-shrink: 0;
  border-right: 1px solid #e5e6eb;
  padding-right: 12px;
  overflow-y: auto;
}

.right-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

:deep(.subHead) { margin-bottom: 8px; }
.tabs-bar {
  margin-bottom: 12px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  overflow-y: auto;
  padding-right: 8px;
  align-content: start;
}

.device-card {
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    border-color: #165dff;
  }
}

.card-header {
  margin-bottom: 12px;
  .device-name {
    font-size: 16px;
    font-weight: 600;
    color: #1d2129;
  }
}

.card-body {
  display: flex;
  gap: 16px;
}

.card-actions {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #f0f1f3;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.device-image {
  width: 120px;
  height: 100px;
  flex-shrink: 0;
  background: #f7f8fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  img { width: 100%; height: 100%; object-fit: cover; }
  .no-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%; height: 100%;
  }
}

.device-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  &.full-width { gap: 6px; }
}

.info-row {
  display: flex;
  .label { color: #86909c; min-width: 70px; flex-shrink: 0; }
  .value { flex: 1; color: #1d2129; }
}

.empty-tip {
  text-align: center;
  color: #c9cdd4;
  padding: 60px 0;
}

.pagination-wrap {
  margin-top: 16px;
  text-align: right;
  flex-shrink: 0;
}

@media (max-width: 1400px) {
  .card-grid { grid-template-columns: repeat(2, 1fr); }
}
</style>
